import { semantic } from '@arcade/web'

import { ArcadeThemeColorsOverride } from './arcadeColors'
import { ThemeColorsOverride } from './colors'

const localPalette = {
  ColorPaletteBlack: '#101010',
  ColorPaletteLightGrey: '#E8E8E8',
  ColorPaletteWhite: '#FFFFFF',
  ColorPaletteHeavyDarkGrey: '#232323',
  ColorPaletteDarkGrey: '#666666',
  ColorPaletteMediumGrey: '#CCCCCC',
  ColorPaletteFadedGrey: '#F0F0F0',
  ColorPaletteDarkGreyText: '#959595',
} as const

export const localArcadeColors: Partial<ArcadeThemeColorsOverride> = {
  // Prominent button colors
  buttonProminentBackgroundDefault: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },
  buttonProminentBackgroundDisabled: {
    light: localPalette.ColorPaletteMediumGrey,
    dark: localPalette.ColorPaletteHeavyDarkGrey,
  },
  buttonProminentBackgroundHover: {
    light: localPalette.ColorPaletteDarkGrey,
    dark: localPalette.ColorPaletteMediumGrey,
  },
  buttonProminentBackgroundPressed: {
    light: localPalette.ColorPaletteDarkGrey,
    dark: localPalette.ColorPaletteMediumGrey,
  },
  buttonProminentTextDefault: {
    light: localPalette.ColorPaletteWhite,
    dark: localPalette.ColorPaletteBlack,
  },
  buttonProminentTextDisabled: {
    light: localPalette.ColorPaletteDarkGreyText,
    dark: localPalette.ColorPaletteDarkGreyText,
  },
  buttonProminentTextPressed: {
    light: localPalette.ColorPaletteDarkGreyText,
    dark: localPalette.ColorPaletteDarkGreyText,
  },
  // Subtle button colors
  buttonSubtleBackgroundHover: {
    light: localPalette.ColorPaletteLightGrey,
    dark: localPalette.ColorPaletteHeavyDarkGrey,
  },
  buttonSubtleBackgroundFocus: {
    light: localPalette.ColorPaletteMediumGrey,
    dark: localPalette.ColorPaletteDarkGrey,
  },
  buttonSubtleBackgroundPressed: {
    light: localPalette.ColorPaletteMediumGrey,
    dark: localPalette.ColorPaletteDarkGrey,
  },
  buttonSubtleTextDefault: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },
  buttonSubtleTextPressed: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },
  buttonSubtleTextDisabled: {
    light: localPalette.ColorPaletteDarkGreyText,
    dark: localPalette.ColorPaletteDarkGreyText,
  },

  // Radio button colors
  radioActiveBorderDefault: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },

  radioActiveBorderDisabled: {
    light: localPalette.ColorPaletteMediumGrey,
    dark: localPalette.ColorPaletteMediumGrey,
  },

  // Checkbox button colors
  checkboxActiveBackgroundDefault: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },

  checkboxActiveBackgroundDisabled: {
    light: localPalette.ColorPaletteMediumGrey,
    dark: localPalette.ColorPaletteMediumGrey,
  },

  // Input colors
  inputBorderSelectedDefault: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },
  inputCursor: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },

  // Toggle colors
  toggleActiveBackgroundDefault: {
    light: localPalette.ColorPaletteBlack,
    dark: localPalette.ColorPaletteWhite,
  },
  toggleInactiveBackgroundDefault: {
    light: localPalette.ColorPaletteLightGrey,
    dark: localPalette.ColorPaletteDarkGrey,
  },
  toggleKnobBackgroundDefault: {
    light: localPalette.ColorPaletteWhite,
    dark: localPalette.ColorPaletteBlack,
  },
}

export const localMooncakeColors = {
  progressBarFill: {
    light: semantic.iconSuccess.light,
    dark: semantic.iconSuccess.dark,
  },
} as ThemeColorsOverride
